import QRCode from 'qrcode'

export interface QRCodeOptions {
  width?: number
  margin?: number
  color?: {
    dark?: string
    light?: string
  }
}

export const generateQRCode = async (
  data: string,
  options: QRCodeOptions = {}
): Promise<string> => {
  try {
    const defaultOptions: QRCodeOptions = {
      width: 200,
      margin: 2,
      color: {
        dark: '#000000',
        light: '#FFFFFF'
      }
    }

    const mergedOptions = {
      ...defaultOptions,
      ...options,
      color: {
        ...defaultOptions.color,
        ...options.color
      }
    }

    const qrCodeDataURL = await QRCode.toDataURL(data, mergedOptions)
    return qrCodeDataURL
  } catch (error) {
    console.error('生成二维码失败:', error)
    throw new Error('生成二维码失败')
  }
}

export const generateDingTalkLoginQRCode = async (
  loginKey: string,
  options?: QRCodeOptions
): Promise<string> => {
  const qrData = `dingtalk://login?key=${loginKey}`
  return generateQRCode(qrData, options)
}
